import React, { ReactNode } from 'react';

import classNames from 'classnames';

import styles from './marker-pin.module.scss';

export type MarkerPinTextProps = {
	children: ReactNode;
	className?: string;
};

export const MarkerPinText = ({ children, className }: MarkerPinTextProps) => (
	<div className={classNames(className, styles.markerPinText)}>{children}</div>
);

export type PinMarkerProps = {
	color: string;
	striped?: boolean;
	title?: string;
	dataTestId: string;
	isSelected?: boolean;
	zIndex?: number;
	opacity?: number;
	textColor?: string;
	borderColor?: string;
	className?: string;
	children?: ReactNode;
};

const DEFAULT_LABEL_COLOR = 'white';

export const MarkerPin = ({
	color,
	striped,
	title,
	dataTestId,
	isSelected,
	zIndex,
	opacity,
	textColor,
	borderColor,
	className,
	children
}: PinMarkerProps) => {
	return (
		<div
			className={classNames(
				className,
				styles.pinMarkerRoot,
				striped && styles.pinMarkerRoot_completedPartially,
				isSelected && styles.pinMarkerRoot_selected
			)}
			style={
				{
					...(!striped ? { backgroundColor: color } : {}),
					...(borderColor ? { borderColor } : {}),
					'--marker-pin-color': color,
					zIndex,
					opacity: opacity ?? 1,
					color: textColor ?? DEFAULT_LABEL_COLOR
				} as React.CSSProperties
			}
			data-test-id={dataTestId}
			title={title}
		>
			{striped ? <span className={styles.pinMarkerStriped} aria-hidden /> : null}
			{children}
		</div>
	);
};
